module.exports = __webpack_public_path__ + "static/media/3.62de9e76.jpg";